import { ReactNode } from "react";
import clsx from "clsx";
import { useTabsContext } from "./TabsContext";

export type TabsListProps = {
  className?: string;
  children: ReactNode;
};

export const TabsList = ({ className, children }: TabsListProps) => {
  const { styles } = useTabsContext();

  const base =
    styles.variant === "blue"
      ? "w-full rounded-xl bg-blue-50/60"
      : styles.variant === "underline"
        ? "w-full border-b border-gray-200"
        : "w-full rounded-xl bg-white";

  const inner =
    styles.variant === "underline"
      ? "flex items-center gap-6"
      : "grid grid-flow-col auto-cols-fr gap-1";

  return (
    <div
      role="tablist"
      aria-orientation="horizontal"
      className={clsx(base, styles.listClassName, className)}
    >
      <div className={inner}>{children}</div>
    </div>
  );
};
